import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    BokkzAlgDataService,
    BokkzIbDataService,
    IncomeTaxEntity,
    JaarrekeningBalans, Onderneming, Ondernemingsvorm
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Event, NavigationEnd, Router } from '@angular/router';
import {
    SpecOmzetbelastingPassivaComponent
} from '../spec-omzetbelasting-passiva/spec-omzetbelasting-passiva.component';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SpecEgalisatiereserveComponent } from '../spec-egalisatiereserve/spec-egalisatiereserve.component';
import { SpecHirComponent } from '../spec-hir/spec-hir.component';
import { SpecForComponent } from '../spec-for/spec-for.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-balans-passiva',
    templateUrl: './balans-passiva.component.html',
    imports: [
        SpecOmzetbelastingPassivaComponent,
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        SpecEgalisatiereserveComponent,
        SpecHirComponent,
        SpecForComponent,
        CommonModule
    ],
    styleUrls: ['./balans-passiva.component.scss']
})
export class BalansPassivaComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription()
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean: boolean = false;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private heeftSamenwerkingsverbandSubscription: Subscription | undefined;

    public labelBalansOpening = '';
    public labelBalansSlot = '';

    public showSpinner = true;

    public eigenVermogenFg = {} as FormGroup;
    public kostenEgalisatieReserveFg = {} as FormGroup;
    public herinvesteringsReserveFg = {} as FormGroup;
    public oudedagesReserveaFg = {} as FormGroup;
    public terugkeerReserveFg = {} as FormGroup;
    public garantieVoorzieningFg = {} as FormGroup;
    public overigeVoorzieningenFg = {} as FormGroup;
    public schuldenLanglopendKredietinstellingenFg = {} as FormGroup;
    public schuldenLanglopendOverigFg = {} as FormGroup;
    public crediteurenFg = {} as FormGroup;
    public schuldenOmzetbelastingFg = {} as FormGroup;
    public schuldenLoonheffingenFg = {} as FormGroup;
    public schuldenKortlopendOverigFg = {} as FormGroup;
    public totalFg = {} as FormGroup;
    public heeftSamenwerkingsverband: boolean = false;

    public dialogVisible = false;

    public showDialog() {
        this.dialogVisible = true;
    }

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public dataService: BokkzIbDataService,
        private dataAlgService: BokkzAlgDataService) {
        this.eigenVermogenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'eigenVermogen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.kostenEgalisatieReserveFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'egalisatieReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.herinvesteringsReserveFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'herinvesteringsReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.oudedagesReserveaFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'oudedagsReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.garantieVoorzieningFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'garantieVoorziening',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.overigeVoorzieningenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'overigeVoorzieningen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.schuldenLanglopendKredietinstellingenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'kredietinstellingen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.schuldenLanglopendOverigFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'langlopendeSchulden',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.crediteurenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'crediteuren',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.schuldenOmzetbelastingFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'omzetbelastingSchuld',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            omzetbelastingDitBoekjaar: null as unknown as number,
            omzetbelastingVorigBoekjaar: null as unknown as number,
            omzetbelastingOudereBoekjaren: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.schuldenLoonheffingenFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'loonheffingSchuld',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        });
        this.schuldenKortlopendOverigFg = this.fb.group<JaarrekeningBalans>({
            omschrijving: 'kortlopendeSchulden',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        });
        this.totalFg = this.fb.group({
            totaalOpening: null as unknown as number,
            totaalSlot: null as unknown as number
        });
    }

    getTotaalPassivaOpening(partner: boolean): number {
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeOpening || 0;
            const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeOpening || 0;
            const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeOpening || 0;
            const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeOpening || 0;
            const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeOpening || 0;
            const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeOpening || 0;
            const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeOpening || 0;
            const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeOpening || 0;
            const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeOpening || 0;
            const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeOpening || 0;
            const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeOpening || 0;
            const eigenVermogen = this.berekenEigenVermogenOpening(partner);
            return eigenVermogen + egalisatieReserve + herinvesteringsreserve + oudedagsreserve + garantieVoorziening + overigeVoorzieningen +
                kredietinstellingen + langlopendeSchulden + crediteuren + omzetbelastingSchuld + loonheffingSchuld +
                kortlopendeSchulden;
        }
        return 0;
    }

    getTotaalPassivaSlot(partner: boolean): number {
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeSlot || 0;
            const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeSlot || 0;
            const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeSlot || 0;
            const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeSlot || 0;
            const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeSlot || 0;
            const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeSlot || 0;
            const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeSlot || 0;
            const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeSlot || 0;
            const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeSlot || 0;
            const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeSlot || 0;
            const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeSlot || 0;
            const eigenVermogen = this.berekenEigenVermogenSlot(partner);
            return eigenVermogen + egalisatieReserve + herinvesteringsreserve + oudedagsreserve + garantieVoorziening + overigeVoorzieningen +
                kredietinstellingen + langlopendeSchulden + crediteuren + omzetbelastingSchuld + loonheffingSchuld +
                kortlopendeSchulden;
        }
        return 0;
    }

    private resetFormGroups() {
        this.eigenVermogenFg.setValue({
            omschrijving: 'eigenVermogen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });
        this.kostenEgalisatieReserveFg.setValue({
            omschrijving: 'egalisatieReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });
        this.herinvesteringsReserveFg.setValue({
            omschrijving: 'herinvesteringsReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });
        this.oudedagesReserveaFg.setValue({
            omschrijving: 'oudedagsReserve',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });

        this.garantieVoorzieningFg.setValue({
            omschrijving: 'garantieVoorziening',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });
        this.overigeVoorzieningenFg.setValue({
            omschrijving: 'overigeVoorzieningen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        }, { emitEvent: false });
        this.schuldenLanglopendKredietinstellingenFg.setValue({
            omschrijving: 'kredietinstellingen',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        }, { emitEvent: false });
        this.schuldenLanglopendOverigFg.setValue({
            omschrijving: 'langlopendeSchulden',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: null as unknown as number
        }, { emitEvent: false });
        this.crediteurenFg.setValue({
            omschrijving: 'crediteuren',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.schuldenOmzetbelastingFg.setValue({
            omschrijving: 'omzetbelastingSchuld',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            omzetbelastingDitBoekjaar: null as unknown as number,
            omzetbelastingVorigBoekjaar: null as unknown as number,
            omzetbelastingOudereBoekjaren: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.schuldenLoonheffingenFg.setValue({
            omschrijving: 'loonheffingSchuld',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.schuldenKortlopendOverigFg.setValue({
            omschrijving: 'kortlopendeSchulden',
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            nominaleWaarde: 0
        }, { emitEvent: false });
        this.totalFg.setValue({
            totaalOpening: null as unknown as number,
            totaalSlot: null as unknown as number
        }, { emitEvent: false });
    }

    public ngOnInit(): void {
        this.subscriptions.add(
            this.partner.subscribe((partner) => {
                this.partnerBoolean = partner;
                this.resetFormGroups();
                this.updateForm();
                this.updateHeeftSamenwerkingsverband();
            })
        );

        this.subscriptions.add(
            this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
                this.incomeTaxEntity = incomeTaxEntity;
                if (incomeTaxEntity.aangifte) {
                    this.resetFormGroups();
                    this.updateForm();
                    this.updateHeeftSamenwerkingsverband();
                }
            })
        );

        this.subscriptions.add(
            this.dataAlgService.client.subscribe((client) => {
                if (client.sstRelationId) {
                    this.clientId = client.sstRelationId;
                }
            })
        );

        this.subscriptions.add(
            this.router.events
                .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
                .subscribe((event: NavigationEnd) => {
                    this.handleUrlChange(event.urlAfterRedirects);
                })
        );
    }

    private updateForm(): void {
        const onderneming = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.[0]
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.[0];

        if (!onderneming) return;

        // eigen vermogen reserves
        const egalisatieReserve = onderneming.eigenVermogen?.find(item => item.omschrijving === 'egalisatieReserve') ?? this.createJaarrekeningBalans('egalisatieReserve');
        const herinvesteringsreserve = onderneming.eigenVermogen?.find(item => item.omschrijving === 'herinvesteringsReserve') ?? this.createJaarrekeningBalans('herinvesteringsReserve');
        const oudedagsreserve = onderneming.eigenVermogen?.find(item => item.omschrijving === 'oudedagsReserve') ?? this.createJaarrekeningBalans('oudedagsReserve');
        this.kostenEgalisatieReserveFg.patchValue(egalisatieReserve, { emitEvent: false });
        this.herinvesteringsReserveFg.patchValue(herinvesteringsreserve, { emitEvent: false });
        this.oudedagesReserveaFg.patchValue(oudedagsreserve, { emitEvent: false });

        // voorzieningen
        const garantieVoorziening = onderneming.voorzieningen?.find(item => item.omschrijving === 'garantieVoorziening') ?? this.createJaarrekeningBalans('garantieVoorziening');
        const overigeVoorzieningen = onderneming.voorzieningen?.find(item => item.omschrijving === 'overigeVoorzieningen') ?? this.createJaarrekeningBalans('overigeVoorzieningen');
        this.garantieVoorzieningFg.patchValue(garantieVoorziening, { emitEvent: false });
        this.overigeVoorzieningenFg.patchValue(overigeVoorzieningen, { emitEvent: false });

        // langlopende schulden
        const kredietinstellingen = onderneming.langlopendeSchulden?.find(item => item.omschrijving === 'kredietinstellingen') ?? this.createJaarrekeningBalans('kredietinstellingen');
        const langlopendeSchulden = onderneming.langlopendeSchulden?.find(item => item.omschrijving === 'langlopendeSchulden') ?? this.createJaarrekeningBalans('langlopendeSchulden');
        this.schuldenLanglopendKredietinstellingenFg.patchValue(kredietinstellingen, { emitEvent: false });
        this.schuldenLanglopendOverigFg.patchValue(langlopendeSchulden, { emitEvent: false });

        // kortlopende schulden
        const crediteuren = onderneming.kortlopendeSchulden?.find(item => item.omschrijving === 'crediteuren') ?? this.createJaarrekeningBalansKortlopendeSchulden('crediteuren');
        const omzetbelastingSchuld = onderneming.kortlopendeSchulden?.find(item => item.omschrijving === 'omzetbelastingSchuld') ?? this.createJaarrekeningBalansKortlopendeSchulden('omzetbelastingSchuld');
        const loonheffingSchuld = onderneming.kortlopendeSchulden?.find(item => item.omschrijving === 'loonheffingSchuld') ?? this.createJaarrekeningBalansKortlopendeSchulden('loonheffingSchuld');
        const kortlopendeSchulden = onderneming.kortlopendeSchulden?.find(item => item.omschrijving === 'kortlopendeSchulden') ?? this.createJaarrekeningBalansKortlopendeSchulden('kortlopendeSchulden');
        this.crediteurenFg.patchValue(crediteuren, { emitEvent: false });
        this.schuldenOmzetbelastingFg.patchValue(omzetbelastingSchuld, { emitEvent: false });
        this.schuldenLoonheffingenFg.patchValue(loonheffingSchuld, { emitEvent: false });
        this.schuldenKortlopendOverigFg.patchValue(kortlopendeSchulden, { emitEvent: false });

        // eigen vermogen (berekend)
        this.eigenVermogenFg.disable({ onlySelf: true });
        let eigenVermogen = onderneming.eigenVermogen?.find(item => item.omschrijving === 'eigenVermogen');
        if (eigenVermogen) {
            eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(this.partnerBoolean);
            eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(this.partnerBoolean);
        } else {
            if (!onderneming.eigenVermogen) {
                onderneming.eigenVermogen = [];
            }
            eigenVermogen = this.createJaarrekeningBalans('eigenVermogen');
            eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(this.partnerBoolean);
            eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(this.partnerBoolean);
            onderneming.eigenVermogen.push(eigenVermogen);
        }
        this.eigenVermogenFg.patchValue(eigenVermogen, { emitEvent: false });

        // totalen
        this.totalFg.patchValue({
            totaalOpening: this.getTotaalPassivaOpening(this.partnerBoolean),
            totaalSlot: this.getTotaalPassivaSlot(this.partnerBoolean)
        });

        /// labels
        let begindatum = new Date;
        if (onderneming.startOnderneming != null) {
            begindatum = onderneming.startOnderneming
        } else {
            begindatum = new Date(this.incomeTaxEntity.aangifte!.aangifteJaar, 0, 1);
        }
        let slotdatum = new Date;
        if (onderneming.datumStaking != null) {
            slotdatum = onderneming.datumStaking
        } else {
            slotdatum = new Date(this.incomeTaxEntity.aangifte!.aangifteJaar, 11, 31);
        }
        this.labelBalansOpening = begindatum != null
            ? `Balans ${new Date(begindatum).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
            : 'Openingsbalans';
        this.labelBalansSlot = slotdatum != null
            ? `Balans ${new Date(slotdatum).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
            : 'Slotbalans';
    }

    // public ngOnInit(): void {
    //     this.subscriptions.add(this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
    //         this.incomeTaxEntity = incomeTaxEntity;
    //         if (incomeTaxEntity.aangifte) {
    //             this.subscriptions.add(this.partner.subscribe((partner) => {
    //                 this.partnerBoolean = partner;
    //                 this.resetFormGroups();
    //                 const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
    //                 if (onderneming) {
    //                     const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'egalisatieReserve') || this.createJaarrekeningBalans('egalisatieReserve');
    //                     const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'herinvesteringsReserve') || this.createJaarrekeningBalans('herinvesteringsReserve');
    //                     const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'oudedagsReserve') || this.createJaarrekeningBalans('oudedagsReserve');
    //                     this.kostenEgalisatieReserveFg.patchValue(egalisatieReserve, { emitEvent: false });
    //                     this.herinvesteringsReserveFg.patchValue(herinvesteringsreserve, { emitEvent: false });
    //                     this.oudedagesReserveaFg.patchValue(oudedagsreserve, { emitEvent: false });
    //
    //                     const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'garantieVoorziening') || this.createJaarrekeningBalans('garantieVoorziening');
    //                     const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'overigeVoorzieningen') || this.createJaarrekeningBalans('overigeVoorzieningen');
    //                     this.garantieVoorzieningFg.patchValue(garantieVoorziening, { emitEvent: false });
    //                     this.overigeVoorzieningenFg.patchValue(overigeVoorzieningen, { emitEvent: false });
    //
    //                     //langlopende schulden
    //                     const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'kredietinstellingen') || this.createJaarrekeningBalans('kredietinstellingen');
    //                     const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null)
    //                         .find(item => item.omschrijving === 'langlopendeSchulden') || this.createJaarrekeningBalans('langlopendeSchulden');
    //                     this.schuldenLanglopendKredietinstellingenFg.patchValue(kredietinstellingen, { emitEvent: false });
    //                     this.schuldenLanglopendOverigFg.patchValue(langlopendeSchulden, { emitEvent: false });
    //
    //                     //kortlopende schulden
    //                     const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren') || this.createJaarrekeningBalansKortlopendeSchulden('crediteuren');
    //                     const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld') || this.createJaarrekeningBalansKortlopendeSchulden('omzetbelastingSchuld');
    //                     const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld') || this.createJaarrekeningBalansKortlopendeSchulden('loonheffingSchuld');
    //                     const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden') || this.createJaarrekeningBalansKortlopendeSchulden('kortlopendeSchulden');
    //                     this.crediteurenFg.patchValue(crediteuren, { emitEvent: false });
    //                     this.schuldenOmzetbelastingFg.patchValue(omzetbelastingSchuld, { emitEvent: false });
    //                     this.schuldenLoonheffingenFg.patchValue(loonheffingSchuld, { emitEvent: false });
    //                     this.schuldenKortlopendOverigFg.patchValue(kortlopendeSchulden, { emitEvent: false });
    //
    //                     //eigen vermogen
    //                     this.eigenVermogenFg.disable({ onlySelf: true });
    //                     let eigenVermogen = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'eigenVermogen');
    //                     if (eigenVermogen) {
    //                         eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(partner);
    //                         eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(partner);
    //                     } else {
    //                         if (!onderneming.eigenVermogen) {
    //                             onderneming.eigenVermogen = [];
    //                         }
    //                         eigenVermogen = this.createJaarrekeningBalans('eigenVermogen');
    //                         eigenVermogen.waardeSlot = this.berekenEigenVermogenSlot(partner);
    //                         eigenVermogen.waardeOpening = this.berekenEigenVermogenOpening(partner);
    //                         onderneming.eigenVermogen.push(eigenVermogen);
    //                     }
    //
    //                     this.eigenVermogenFg.patchValue(eigenVermogen, { emitEvent: false });
    //                     const totaalPassivaSlot = this.getTotaalPassivaSlot(partner);
    //                     const totaalPassivaOpening = this.getTotaalPassivaOpening(partner);
    //                     this.totalFg.patchValue({ totaalOpening: totaalPassivaOpening, totaalSlot: totaalPassivaSlot });
    //
    //                     const begindatum = onderneming.boekjaar.begindatum;
    //                     this.labelBalansOpening = begindatum != null
    //                         ? `Balans ${new Date(begindatum).toLocaleDateString('nl-NL', {
    //                             day: '2-digit',
    //                             month: '2-digit',
    //                             year: 'numeric'
    //                         })}` : 'Openingsbalans';
    //                     const slotdatum = onderneming.boekjaar.einddatum;
    //                     this.labelBalansSlot = slotdatum != null
    //                         ? `Balans ${new Date(slotdatum).toLocaleDateString('nl-NL', {
    //                             day: '2-digit',
    //                             month: '2-digit',
    //                             year: 'numeric'
    //                         })}` : 'Openingsbalans';
    //                 }
    //                 this.updateHeeftSamenwerkingsverband();
    //             }));
    //         }
    //     }));
    //     this.subscriptions.add(this.dataAlgService.client.subscribe((client) => {
    //         if (client.sstRelationId) {
    //             this.clientId = client.sstRelationId;
    //         }
    //     }));
    //     this.subscriptions.add(this.router.events.pipe(filter(
    //         (event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    //         this.handleUrlChange(event.urlAfterRedirects);
    //     }));
    //
    // }

    private updateHeeftSamenwerkingsverband(): void {
        const ondernemingen = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen;

        if (ondernemingen && ondernemingen.length > 0 && ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
            this.heeftSamenwerkingsverband = ondernemingen[0].invullenOpNiveauSamenwerkingsverband != undefined && ondernemingen[0].invullenOpNiveauSamenwerkingsverband ;
        } else {
            this.heeftSamenwerkingsverband = false;
        }
    }


    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.heeftSamenwerkingsverbandSubscription) {
            this.heeftSamenwerkingsverbandSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.eigenVermogenFg.dirty ||
            this.kostenEgalisatieReserveFg.dirty ||
            this.herinvesteringsReserveFg.dirty ||
            this.oudedagesReserveaFg.dirty ||
            this.terugkeerReserveFg.dirty ||
            this.garantieVoorzieningFg.dirty ||
            this.overigeVoorzieningenFg.dirty ||
            this.schuldenLanglopendKredietinstellingenFg.dirty ||
            this.schuldenLanglopendOverigFg.dirty ||
            this.crediteurenFg.dirty ||
            this.schuldenOmzetbelastingFg.dirty ||
            this.schuldenLoonheffingenFg.dirty ||
            this.schuldenKortlopendOverigFg.dirty ||
            this.totalFg.dirty;
    }


    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                box1: {
                    ...this.incomeTaxEntity.aangifte?.box1,
                    winstUitOnderneming: {
                        ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                        ondernemingen: [
                            {
                                ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                eigenVermogen: [this.eigenVermogenFg.getRawValue(), this.kostenEgalisatieReserveFg.getRawValue(), this.herinvesteringsReserveFg.getRawValue(), this.oudedagesReserveaFg.getRawValue()],
                                voorzieningen: [this.garantieVoorzieningFg.getRawValue(), this.overigeVoorzieningenFg.getRawValue()],
                                langlopendeSchulden: [this.schuldenLanglopendKredietinstellingenFg.getRawValue(), this.schuldenLanglopendOverigFg.getRawValue()],
                                kortlopendeSchulden: [this.crediteurenFg.getRawValue(), this.schuldenOmzetbelastingFg.getRawValue(), this.schuldenLoonheffingenFg.getRawValue(), this.schuldenKortlopendOverigFg.getRawValue()]
                            }]
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                partnerAangifte: {
                    ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                    box1: {
                        ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
                        winstUitOnderneming: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                            ondernemingen: [
                                {
                                    ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0],
                                    eigenVermogen: [this.eigenVermogenFg.getRawValue(), this.kostenEgalisatieReserveFg.getRawValue(), this.herinvesteringsReserveFg.getRawValue(), this.oudedagesReserveaFg.getRawValue()],
                                    voorzieningen: [this.garantieVoorzieningFg.getRawValue(), this.overigeVoorzieningenFg.getRawValue()],
                                    langlopendeSchulden: [this.schuldenLanglopendKredietinstellingenFg.getRawValue(), this.schuldenLanglopendOverigFg.getRawValue()],
                                    kortlopendeSchulden: [this.crediteurenFg.getRawValue(), this.schuldenOmzetbelastingFg.getRawValue(), this.schuldenLoonheffingenFg.getRawValue(), this.schuldenKortlopendOverigFg.getRawValue()]
                                }]
                        }
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    berekenEigenVermogenSlot(partner: boolean): number {
        let totaalActiva = 0;
        let totaalPassivaZonderEv = 0;
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            //immateriele vaste activa
            const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeSlot || 0;
            const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeSlot || 0;
            const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeSlot || 0;
            const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeSlot || 0;
            const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeSlot || 0;
            const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeSlot || 0;
            const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeSlot || 0;
            const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeSlot || 0;
            const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeSlot || 0;
            const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeSlot || 0;
            const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeSlot || 0;
            const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeSlot || 0;
            const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeSlot || 0;

            totaalActiva = goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + financieleVasteActiva + voorraad +
                onderhandenWerk + debiteuren + omzetbelastingVordering + overigeVorderingen + effecten + liquideMiddelen;
            const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeSlot || 0;
            const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeSlot || 0;
            const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeSlot || 0;
            const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeSlot || 0;
            const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeSlot || 0;
            const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeSlot || 0;
            const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeSlot || 0;
            const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeSlot || 0;
            const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeSlot || 0;
            const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeSlot || 0;
            const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeSlot || 0;

            totaalPassivaZonderEv = egalisatieReserve + oudedagsreserve + herinvesteringsreserve + garantieVoorziening + overigeVoorzieningen + kredietinstellingen + langlopendeSchulden +
                crediteuren + loonheffingSchuld + omzetbelastingSchuld + kortlopendeSchulden;
            return totaalActiva - totaalPassivaZonderEv;
        }
        return 0;
    }

    berekenEigenVermogenOpening(partner: boolean): number {
        let totaalActiva = 0;
        let totaalPassivaZonderEv = 0;
        const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
        if (onderneming) {
            //immateriele vaste activa
            const goodWill = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'goodwill')?.waardeOpening || 0;
            const immaterieleVasteActiva = onderneming?.immaterieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'immaterieleVasteActiva')?.waardeOpening || 0;
            const bedrijfsGebouwen = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'bedrijfsGebouwen')?.waardeOpening || 0;
            const machinesEnInstallaties = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'machinesEnInstallaties')?.waardeOpening || 0;
            const andereVasteActiva = onderneming?.materieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'andereVasteActiva')?.waardeOpening || 0;
            const financieleVasteActiva = onderneming?.financieleVasteActiva?.filter(item => item !== null).find(item => item.omschrijving === 'financieleVasteActiva')?.waardeOpening || 0;
            const onderhandenWerk = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'onderhandenWerk')?.waardeOpening || 0;
            const voorraad = onderneming?.vlottendeActivaVoorraad?.filter(item => item !== null).find(item => item.omschrijving === 'voorraad')?.waardeOpening || 0;
            const debiteuren = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'debiteuren')?.waardeOpening || 0;
            const omzetbelastingVordering = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingVordering')?.waardeOpening || 0;
            const overigeVorderingen = onderneming?.vlottendeActivaVorderingen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVorderingen')?.waardeOpening || 0;
            const effecten = onderneming?.effecten?.filter(item => item !== null).find(item => item.omschrijving === 'effecten')?.waardeOpening || 0;
            const liquideMiddelen = onderneming?.liquideMiddelen?.filter(item => item !== null).find(item => item.omschrijving === 'liquideMiddelen')?.waardeOpening || 0;

            totaalActiva = goodWill + immaterieleVasteActiva + bedrijfsGebouwen + machinesEnInstallaties + andereVasteActiva + financieleVasteActiva + voorraad +
                onderhandenWerk + debiteuren + omzetbelastingVordering + overigeVorderingen + effecten + liquideMiddelen;

            const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve')?.waardeOpening || 0;
            const oudedagsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'oudedagsReserve')?.waardeOpening || 0;
            const herinvesteringsreserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve')?.waardeOpening || 0;
            const garantieVoorziening = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'garantieVoorziening')?.waardeOpening || 0;
            const overigeVoorzieningen = onderneming?.voorzieningen?.filter(item => item !== null).find(item => item.omschrijving === 'overigeVoorzieningen')?.waardeOpening || 0;
            const kredietinstellingen = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kredietinstellingen')?.waardeOpening || 0;
            const langlopendeSchulden = onderneming?.langlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'langlopendeSchulden')?.waardeOpening || 0;
            const crediteuren = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'crediteuren')?.waardeOpening || 0;
            const omzetbelastingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'omzetbelastingSchuld')?.waardeOpening || 0;
            const loonheffingSchuld = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'loonheffingSchuld')?.waardeOpening || 0;
            const kortlopendeSchulden = onderneming?.kortlopendeSchulden?.filter(item => item !== null).find(item => item.omschrijving === 'kortlopendeSchulden')?.waardeOpening || 0;

            totaalPassivaZonderEv = egalisatieReserve + oudedagsreserve + herinvesteringsreserve + garantieVoorziening + overigeVoorzieningen + kredietinstellingen + langlopendeSchulden +
                crediteuren + loonheffingSchuld + omzetbelastingSchuld + kortlopendeSchulden;
            return totaalActiva - totaalPassivaZonderEv;
        }
        return 0;
    }

    private createJaarrekeningBalans(omschrijving: string): JaarrekeningBalans {
        return {
            omschrijving: omschrijving,
            waardeOpening: undefined as unknown as number,
            waardeSlot: undefined as unknown as number,
            aanschafWaarde: undefined as unknown as number,
            restWaarde: undefined as unknown as number,
            nominaleWaarde: 0,
            bodemwaarde: undefined as unknown as number,
            omzetbelastingDitBoekjaar: undefined as unknown as number,
            omzetbelastingVorigBoekjaar: undefined as unknown as number,
            omzetbelastingOudereBoekjaren: undefined as unknown as number
        } as JaarrekeningBalans;
    }

    private createJaarrekeningBalansKortlopendeSchulden(omschrijving: string): JaarrekeningBalans {
        return {
            omschrijving: omschrijving,
            waardeOpening: undefined as unknown as number,
            waardeSlot: undefined as unknown as number,
            aanschafWaarde: undefined as unknown as number,
            restWaarde: undefined as unknown as number,
            nominaleWaarde: 0,
            bodemwaarde: undefined as unknown as number,
            omzetbelastingDitBoekjaar: undefined as unknown as number,
            omzetbelastingVorigBoekjaar: undefined as unknown as number,
            omzetbelastingOudereBoekjaren: undefined as unknown as number
        } as JaarrekeningBalans;
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.box1 &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }

    private getRelevantAangifte(): Aangifte | undefined {
        return this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte
            : this.incomeTaxEntity.aangifte;
    }

    private getOndernemingen(): Onderneming[] | undefined {
        const aangifte = this.getRelevantAangifte();
        return aangifte?.box1?.winstUitOnderneming?.ondernemingen;
    }
}
